<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/classificacoes"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <ClassificacaoFormulario @send="criar" :item="item" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Classificação criada com sucesso"
      @close="goTo"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { storeClassification } from "@/services/classification.js";
import ClassificacaoFormulario from "@/components/classificacoes/ClassificacaoFormulario.vue";
export default {
  name: "ClassificacaoCriar",
  components: { ClassificacaoFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Classificações",
        disabled: false,
        to: "/classificacoes",
      },
      {
        text: "Criar Classificação",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    item: {},
    loading: false,
  }),
  methods: {
    async criar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await storeClassification(event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.message;
      }
    },
    goTo() {
      this.sucess = false;
      this.$router.push({ name: "Classificacoes" });
    },
  },
};
</script>

<style></style>
